<template>
  <table class="fixed_header ventesNumeriquePlanningChildRowTable">
    <tr v-for="face in data.faces" :key="face.facNum">
      <td class="ventesNumeriquePlanningChildRowCalage"></td>
      <td class="ventesNumeriquePlanningTailleColonneIcon"><b-icon icon="video"></b-icon></td>
      <td class="ellipsis ventesNumeriquePlanningTailleColonneCode">{{ face.facCode }}</td>
      <td class="ellipsis ventesNumeriquePlanningTailleColonneAdresse"></td>
      <td class="ventesNumeriquePlanningTailleColonnePlanning">
        <planning :data="face"></planning>
      </td>
    </tr>
  </table>
</template>


<script>
import PlanningChildSvg from './planningNumeriqueChildSvg';

export default {
  props: ['data'],
  components: {
    planning: PlanningChildSvg,
  },
};

</script>

<style>

.ventesNumeriquePlanningChildRowTable {
  width: 100%;
}

.ventesNumeriquePlanningChildRowTable,
.ventesNumeriquePlanningChildRowTable tr {
  border-style: none;
  border-width: 0;
}

.ventesNumeriquePlanningChildRowTable td {
  border-top-width: 0 !important;
}

.ventesNumeriquePlanningChildRowCalage {
  min-width: 45px !important;
  max-width: 45px !important;
  width: 45px;
  text-align: center;
  border-left-width: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/planningChildRowFace.vue